import { defaultFetch } from "../utils/auth";

export const readImage = async(imageId: number) :Promise<any> => {
    try{
        let url = `/api/backend/images?id=${imageId}`
        const res = await defaultFetch(url);
        if (res.status >= 400 && res.status < 600) {
            throw new Error("Server not returned a valid response")
        }
        return res
    } catch (error) {
        let message
        if (error instanceof Error) {
            message = error.message
        } else {
            message = 'Unable to fetch image'
        } 
        return { error: message };
    }
};